export const Rules = {
  MAX_TITLE: 120,
  MAX_CATEGORY: 22,
  MIN_CATEGORY: 2,
  MAX_CAMPAIGN_TITLE: 100,
  MAX_PROFILE_TITLE: 50,
  MAX_CONTENT: 63206,
};
